import { Link, useNavigate } from "react-router-dom";
import styles from './MobileMenu.module.scss';

export default function MobileMenu({auth, onCloseOffCanvas}) {
    const navigate = useNavigate();

    const handleLink = (link) => {
        navigate(`${link}`);
        onCloseOffCanvas();
    }
    
  return (
    <div className="d-flex flex-column h-100">
        <div className='bottonDivider mb-3'></div>
        <div className={`${styles.navBox} d-block`}>
            <ul className={`list-unstyled ${styles.mobileNav}`}>
                <li>
                    <span onClick={() => handleLink(`${auth?.token ? '/dashboard/add-product/' : '/login'}`)} className={`${styles.navLink}`}>
                        Listing
                    </span>
                </li>
                <li>
                    <Link to={`/categories`} className={`${styles.navLink}`}>
                        Categories
                    </Link>
                </li>
                <li>
                    <Link to={`/about-us`} className={`${styles.navLink}`}>
                        About us
                    </Link>
                </li>
                <li>
                    <Link to={`/contact-us`} className={`${styles.navLink}`}>
                        Contact us
                    </Link>
                </li>
            </ul>
        </div>
        <div className="mt-auto d-block">
            <div className='bottonDivider my-3'></div>
            {
                auth
                    ? <span 
                        onClick={() => handleLink('/dashboard/user-profile/')}
                        className="my-3 py-2 d-flex align-items-center text-decoration-none justify-content-between text-tertiary"
                        >
                        <span className="fw-bold">
                            {auth?.user}
                        </span>
                        <i className='bi bi-chevron-right'></i>
                      </span>
                    : <Link 
                        to={'/login'}
                        className="my-3 py-2 d-flex align-items-center text-decoration-none"
                        >
                        <span className="fw-bold">Login / Register</span>
                      </Link>
            }
                
            
        </div>
    </div>
  )
}
